import React, { useState } from "react";
import { IconButton, Tooltip, CircularProgress } from "@material-ui/core";
import { Sms as SmsIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import SendSmsModal from "../SendSmsModal";
import useSmsEnabled from "../../hooks/useSmsEnabled";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
  button: {
    color: "grey",
  },
}));

const SmsButton = ({ contact, ticketId }) => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const { enabled, loading } = useSmsEnabled();

  const handleSmsSuccess = async () => {
    // Atualiza saldo silenciosamente
    try {
      await api.get("/sms/balance");
    } catch (error) {
      console.log("Erro ao atualizar saldo SMS:", error);
    }
  };

  if (loading) {
    return (
      <IconButton disabled size="small">
        <CircularProgress size={20} />
      </IconButton>
    );
  }

  if (!enabled) {
    return null; // Não exibe o botão se SMS não estiver configurado
  }

  return (
    <>
      <Tooltip title="Enviar SMS">
        <IconButton
          className={classes.button}
          size="small"
          onClick={() => setModalOpen(true)}
        >
          <SmsIcon />
        </IconButton>
      </Tooltip>

      <SendSmsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        contact={contact}
        ticketId={ticketId}
        onSuccess={handleSmsSuccess}
      />
    </>
  );
};

export default SmsButton;
